var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          ref: "select",
          staticClass: "wp-10",
          attrs: {
            filterable: "",
            remote: "",
            placeholder: _vm.$t.__("common.actions.search"),
            "remote-method": _vm.remoteMethod,
            loading: _vm.loading,
            "loading-text": _vm.$t.__("common.labels.loading"),
            "popper-class": "to-the-top"
          },
          on: { change: _vm.selectCosign, focus: _vm.focusingSearch },
          model: {
            value: _vm.value,
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        },
        _vm._l(_vm.options, function(item) {
          return _c(
            "el-option",
            { key: item.id, attrs: { label: item.lastName, value: item.id } },
            [
              _c("div", { staticClass: "flex-row jc-space" }, [
                _c("span", [_vm._v(_vm._s(item.name))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(item.email))])
              ])
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }